import { ModelRow } from "@mcleod/core";
import { AutogenLayoutChangeStopRefnoNoChangeCompareItems } from "./autogen/AutogenLayoutChangeStopRefnoNoChangeCompareItems";
import { BaseCompare } from "./BaseCompare";
import { DataSourceMode } from "@mcleod/components/src/databinding/DataSource";
import { TableRowDisplayEvent } from "@mcleod/components/src/events/TableRowDisplayEvent";

export class ChangeStopRefnoNoChangeCompareItems extends AutogenLayoutChangeStopRefnoNoChangeCompareItems {
    private _compareItems: ModelRow[];
    private baseCompare = new BaseCompare();

    // Delegate properties to baseCompare
    get isOrderUpdateAllowed(): boolean { return this.baseCompare.isOrderUpdateAllowed; }
    set isOrderUpdateAllowed(value: boolean) { this.baseCompare.isOrderUpdateAllowed = value; }

    get compareItems(): ModelRow[] { return this._compareItems; }
    set compareItems(value: ModelRow[]) { this._compareItems = value; }

    get isInvoice(): boolean { return this.baseCompare.isInvoice; }
    set isInvoice(value: boolean) { this.baseCompare.isInvoice = value; }

    get isCompareHistory(): boolean { return this.baseCompare.isCompareHistory; }
    set isCompareHistory(value: boolean) { this.baseCompare.isCompareHistory = value; }

    override onLoad(): void | Promise<void> {
        this.tableRefnoChanges.dataSource;
        this.tableRefnoChanges.dataSource = this.sourceStopRefnoChangeCompareItem;
        this.tableRefnoChanges.dataSource.data = [];
    }

    public async setupTableData(data: ModelRow[]) {
        this._compareItems = data;
        if (this._compareItems != null)
            this.tableRefnoChanges.dataSource.setRowsAndMode(DataSourceMode.NONE, this._compareItems);

        if (this._compareItems != null && this._compareItems.length == 0) {
            this.tableRefnoChanges.visible = false;
        }
    }

    onItemRowDisplay(event: TableRowDisplayEvent) {
        const allowed = event.getTableRow().data.getBoolean("allowed");
        this.baseCompare.isOrderUpdateAllowed = allowed;
        this.baseCompare.setupCheckboxBehavior(event.getTableRow(), this.isOrderUpdateAllowed, false);
    }
}